export const googleConfig = {
    clientID: '194331860536-6ui47eoc4m85il52jhep0ho85iffjuco.apps.googleusercontent.com'
}